module.exports = __webpack_public_path__ + "static/media/ic_filter_blue.81bf4c36.svg";